import { useState } from 'react';
import { WorkplaceDoctorStatisticsFilterValues } from '../Components/WorkplaceDoctorStatisticsFilter';
import { useEffectAsync } from '../../../helpers';
import useApiClient from '../../Base/Hooks/useApiClient';
import apiClient from '../../../Services/ApiClient';
import { formatObjectForQuery } from '../../../Services/Api/FormatObjectForQuery';
import moment from 'moment';

interface WorkplaceDoctorStatisticsDataValue {
	adult: string;
	child: string;
	total: string;
}

export interface WorkplaceDoctorStatisticsCaseInsurance {
	insuranceCompanyCode: string;
	count: WorkplaceDoctorStatisticsDataValue;
}

export type WorkplaceDoctorStatisticsData =
	| {
			key: 'caseInsurance';
			value: WorkplaceDoctorStatisticsCaseInsurance[];
	  }
	| {
			key: Exclude<string, 'caseInsurance'>;
			value: WorkplaceDoctorStatisticsDataValue;
	  };

const DEFAULT_VALUES = {
	from: moment().subtract(1, 'month'),
	to: moment(),
};

export default function useWorkplaceDoctorStatistics(isFilterReady: boolean) {
	const [data, setData] = useState<WorkplaceDoctorStatisticsData[]>([]);
	const [filter, setFilter] =
		useState<WorkplaceDoctorStatisticsFilterValues>(DEFAULT_VALUES);
	const { displayError } = useApiClient();

	useEffectAsync(async () => {
		if (!isFilterReady) {
			return;
		}

		const params = formatObjectForQuery({
			from: filter?.from?.format('YYYY-MM-DD'),
			to: filter?.to?.format('YYYY-MM-DD'),
		});

		try {
			const response = await apiClient.get(`/statistics/doctor?${params}`);
			if (response.status === 200) {
				setData(response.data.data);
			}
		} catch (e) {
			displayError(e);
		}
	}, [filter, isFilterReady]);

	return {
		data,
		setFilter,
	};
}
